import {
  DP_ANALYTICS_ACT,
  DP_ANALYTICS_ACT_ERROR,
  DP_ANALYTICS_ACT_SUCCESS,
  DP_ANALYTICS_CLEAR,
  DP_ANALYTICS_LOAD,
  DP_ANALYTICS_LOAD_ERROR,
  DP_ANALYTICS_LOAD_SUCCESS,
} from './types';

const initialState = {
  demand: null,
  snapshots: [],
  narrative: null,
  gaps: null,
  bottlenecks: null,
  insight: null,
  impact: null,
  loading: {},
  error: {},
  acting: false,
};

const degreePlanningAnalyticsReducer = (state = initialState, action) => {
  switch (action.type) {
    case DP_ANALYTICS_LOAD:
      return { ...state, loading: { ...state.loading, [action.key]: true }, error: { ...state.error, [action.key]: false } };
    case DP_ANALYTICS_LOAD_SUCCESS:
      return { ...state, loading: { ...state.loading, [action.key]: false }, [action.key]: action.payload };
    case DP_ANALYTICS_LOAD_ERROR:
      return { ...state, loading: { ...state.loading, [action.key]: false }, error: { ...state.error, [action.key]: true } };
    case DP_ANALYTICS_ACT:
      return { ...state, acting: true };
    case DP_ANALYTICS_ACT_SUCCESS:
    case DP_ANALYTICS_ACT_ERROR:
      return { ...state, acting: false };
    case DP_ANALYTICS_CLEAR:
      return (action.keys || []).reduce((next, key) => ({ ...next, [key]: initialState[key] }), state);
    default:
      return state;
  }
};

export default degreePlanningAnalyticsReducer;
